import Vue from 'vue';
import Router from 'vue-router';
import SampleLayout from './../pages/Starter/SampleLayout.vue';
import AuthLayout from 'src/pages/Pages/AuthLayout.vue';
// import Starter from './../pages/Starter/SamplePage.vue';
import Dash from './../pages/Starter/Dash.vue';

Vue.use(Router);

const Login = () => import(/* webpackChunkName: "pages" */ 'src/pages/Pages/Login.vue');

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/dashboard',
      component: SampleLayout,
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          components: { default: Dash }
        }
      ]
    },
    {
      path: '/',
      component: AuthLayout,
      name: 'Authentication',
      redirect: '/login',
      children: [
        {
          path: '/login',
          name: 'Login',
          component: Login
        }
      ]
    }
  ],
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});
